<template>
  <div class="home page">
    <div
      class="position-relative overflow-hidden p-3 p-md-5 m-lg-3 text-center bg-light"
    >
      <div class="col-md-5 p-lg-5 mx-auto my-5">
        <h1 class="display-4 fw-normal">DukGO</h1>
        <p class="lead fw-normal">One touch, Infinite possibilities.</p>
        <div class="downloads">
          <a href="/">
            <img src="@/assets/appstore.svg" alt="app store icon" height="50"/>
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.dk040106.dukgo"
          >
            <img src="@/assets/playstore.svg" alt="play store icon" height="50"/>
          </a>
        </div>
      </div>
      <div class="product-device shadow-sm d-none d-lg-block"></div>
      <div
        class="product-device product-device-2 shadow-sm d-none d-lg-block"
      ></div>
    </div>

    <div class="youtube-wrapper m-lg-3">
      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/k66vAToE0ls"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
};
</script>

<style scoped>
a {
  margin: 10px;
}
.product-device {
  position: absolute;
  right: 5%;
  bottom: -25%;
  width: 300px;
  height: 540px;
  background-color: #333;
  border-radius: 21px;
  transform: rotate(30deg);
}

.product-device::before {
  position: absolute;
  top: 10%;
  right: 10px;
  bottom: 10%;
  left: 10px;
  content: "";
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 5px;
}

.product-device-2 {
  top: -25%;
  right: auto;
  bottom: 0;
  left: 5%;
  background-color: #e5e5e5;
}

.youtube-wrapper {
  position: relative;
  /* 16:9 */
  height: 0;
}

.youtube-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

@media (min-width: 992px) {
  .youtube-wrapper {
    position: relative;
  }
  .youtube-wrapper iframe {
    position: relative;
    width: 720px;
    height: 405px;
    padding-bottom: none;
  }
}

@media (max-width: 992px) {
  .youtube-wrapper {
    padding-bottom: 56.25%;
  }
}
</style>